import React from "react";

import PrimaryAttributeHeader from "@is/components/PrimaryAttributeHeader";

import css from "./SearchHeader.module.css";
import useManageSearchHeader from "./hooks/useManageSearchHeader";

const SearchHeader = () => {
  const {
    attributes,
    handleAttributeClick,
    handleToggleLanguageAndCurrencyModal,
    handleToggleSignUpModal,
    signUpButtonTitle,
    showSignUpButton,
  } = useManageSearchHeader();

  return (
    <div className={css.container}>
      <PrimaryAttributeHeader
        attributes={attributes}
        onAttributeClick={handleAttributeClick}
        onLanguageAndCurrencyClick={handleToggleLanguageAndCurrencyModal}
        onSignUpClick={handleToggleSignUpModal}
        signUpButtonTitle={signUpButtonTitle}
        showSignUpButton={showSignUpButton}
      />
    </div>
  );
};

export default SearchHeader;
